import { useState, useEffect } from 'react';
import { deleteMovie, isOwner } from "../../firebase";
import styles from './MovieList.module.css';
import { selectUsers } from '../store/usersSlice';
import { useSelector } from 'react-redux';

// Components
import Button from "../Button/Button";

export default function Movies(props) {
  const [owner, setOwner] = useState(false);
  const user = useSelector(selectUsers);
  const { movieName, submittedName, struck, onToggleStruck } = props;
  const handleRemove = (e) => {
    e.stopPropagation();
    deleteMovie(props.listId, props.movieId);
  }

  useEffect(() => {
    const checkOwner = async () => {
      const result = await isOwner(user.currentUser.id, props.listId);
      setOwner(result)
    };

    checkOwner();
  }, [user.currentUser.id, props.listId]);

  return (
    <div className={styles.movieSlice}>
      <p className={struck ? styles.struck : ""}
        onClick={onToggleStruck}
        style={{cursor: "pointer"}}
        role="button"

      >{movieName} <span className="submitted_name">{submittedName}</span></p>
      {owner && 
      <Button buttonText="X" handleFunction={handleRemove} />
      }
    </div>
  )
}
